import * as Sentry from '@sentry/node';
import os from 'os';
import pkgJson from '../../package.json';
import { getAuthConfig } from './configStore';
import getProjectConfig from './projectConfig/getProjectConfig';
import getEnvironmentVariables from './getEnvironmentVariables';

export default () => {
  const { TODESKTOP_CLI_SENTRY_DSN } = getEnvironmentVariables();
  if (!TODESKTOP_CLI_SENTRY_DSN) {
    // Don't initialise Sentry
    return;
  }
  Sentry.init({
    dsn: TODESKTOP_CLI_SENTRY_DSN,
  });

  const scope = Sentry.getCurrentScope();
  try {
    scope.setUser({ email: getAuthConfig().email as string });
  } catch {
    // nothing
  }
  try {
    scope.setContext('os', {
      name: os.platform(),
      version: os.release(),
    });
  } catch {
    // nothing
  }

  try {
    scope.setContext('runtime', {
      name: 'Node.js',
      version: process.version,
    });
  } catch {
    // nothing
  }

  try {
    scope.setContext('app', {
      app_name: pkgJson.name,
      app_version: pkgJson.version,
    });
  } catch {
    // nothing
  }

  try {
    const configResult = getProjectConfig();
    scope.setExtra('config', configResult);
  } catch {
    // nothing
  }
};
